import { Card, Typography } from '@mui/material';
import { LoadingSpinner } from 'components/data/LoadingSpinner';
import { RankData } from '../../EfficiencyRank';

interface RankingCardsProps {
    isLoading: boolean;
    rankData: RankData;
}

export const RankingCards = ({ isLoading, rankData }: RankingCardsProps) => {
    return (
        <div data-testid="RankingCards">
            <Card
                sx={{
                    marginBottom: '1rem',
                    padding: '1rem',
                    textAlign: 'center',
                }}
            >
                <p>You rank</p>
                <Typography variant="h3" color="primary">
                    {isLoading ? <LoadingSpinner /> : rankData.rank}
                </Typography>
                <span>
                    out of{' '}
                    <b>
                        {isLoading ? (
                            <LoadingSpinner size="sm" />
                        ) : (
                            rankData.total
                        )}
                    </b>{' '}
                    total regional fuel suppliers
                </span>
            </Card>
            <Card
                sx={{
                    marginBottom: '1rem',
                    padding: '1rem',
                    textAlign: 'center',
                }}
            >
                <p>
                    This means you are likely earning more revenue per delivery
                    than
                </p>
                <Typography variant="h3" color="primary">
                    {isLoading ? <LoadingSpinner /> : rankData.percentile + '%'}
                </Typography>
                <p>of other fuel suppliers</p>
            </Card>
        </div>
    );
};
